import BetaChannelService from "./BetaChannelService";
import BetaChannelApiRouteService from "./BetaChannelApiRouteService";

class NakiBoltBetaChannelService extends BetaChannelService {
    constructor(apiClient) {
        super(apiClient, new BetaChannelApiRouteService("naki-bolt-beta-channels"));
    }
}

export default NakiBoltBetaChannelService;
